import React from 'react'

// Re-export ChartistDonutGraphNonLazy with React.lazy
export const ChartistDonutGraph = React.lazy(() => import('./ChartistDonutGraphNonLazy'))
